export default __webpack_public_path__ + "static/media/yellow-double-checkmark.69e15c95.svg";